module.exports = "<div class=\"input-group num-input-group\">\r\n    <div class=\"input-group-prepend\">\r\n        <button class=\"btn\" @click=\"calc(-1)\">-</button>\r\n    </div>\r\n    <input type=\"text\" class=\"form-control\" v-model=\"num\">\r\n    <div class=\"input-group-append\">\r\n        <button class=\"btn\" @click=\"calc(1)\">+</button>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!../common/component/num-input-group.html
// module id = 235
// module chunks = 0